import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'app/_services/common.service'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HistoryDetailsComponent } from './history-details/history-details.component';


@Component({
  selector: 'app-user-history',
  templateUrl: './user-history.component.html',
  styleUrls: ['./user-history.component.css']
})
export class UserHistoryComponent implements OnInit {

  dataSource;
  public usersList;
  public data;
  public sortDir = 1;
  displayedColumns: string[] = [
  'search_term','pincode','created_at','action'];
  public userHistoryList ; 
  public currentUser;
  public isLoggedIn;


  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    public dialog: MatDialog,

  ) { }

  ngOnInit(): void {
    this.getUserHistory();
  }


  getUserHistory(){
    let userId;
    this.isLoggedIn = localStorage.getItem('isLoggedIn');
    this.currentUser =  JSON.parse(localStorage.getItem('currentUser'));

    if(this.isLoggedIn === "true" && this.currentUser != null && this.currentUser != undefined){
      userId =  this.currentUser.data.user_id
      let input : {}
      input = {
        user_id : userId
        // user_id  : 1
      }
      this.commonService.getUserHistory(input).subscribe( res => {
        this.userHistoryList = res.body.data;
        this.userHistoryList.sort((a,b)=>{
          return this.sortDir = -1;
      });
      }, err => console.error('Cannot Fetch users history List' + err))
    }
    else{
      console.log('No History Found');
      alert("No History Found");
      this.router.navigate(['/login'])
    }

  }

  toLogin(){
    this.router.navigate(['/login'])
  }

  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn === "true") {
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login");
      this.router.navigate(['/login'])

    }
  }

  navigateMenu() {
    this.router.navigate(['/food-service']);
    // this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }

  openDialog(action: any, obj: any, element: any, i: any) {
    const dialogConfig = new MatDialogConfig();
    obj.action = action;
    obj.index = i;
    if (element != null) {
      obj.id = element;
    }
    obj.htmlData = document.getElementById("card_" + i);
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = obj;
    let dialogRef;
    if (action === 'historyDetails') {
      dialogRef = this.dialog.open(HistoryDetailsComponent, dialogConfig);
    }
   



    dialogRef.afterClosed().subscribe(result => {
      if (result.event === 'historyDetails' && result.isUpdated === true) {
        this.showNotification('bottom', 'right', 'success', 'Data Captured successful', 'announcement');
      }
    
    });
  }

  showNotification(from, align, color, stringMessage, icons) {
    const type = ['', 'info', 'success', 'warning', 'danger'];



    // $.notify({
    //   icon: icons,
    //   message: stringMessage

    // }, {
    //   type: type[color],
    //   timer: 4000,
    //   placement: {
    //     from: from,
    //     align: align
    //   },
    //   template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
    //     '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
    //     '<i class="material-icons" data-notify="icon">notifications</i> ' +
    //     '<span data-notify="title">{1}</span> ' +
    //     '<span data-notify="message">{2}</span>' +
    //     '<div class="progress" data-notify="progressbar">' +
    //     '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
    //     '</div>' +
    //     '<a href="{3}" target="{4}" data-notify="url"></a>' +
    //     '</div>'
    // });
  }


  //sort function
  onSortClick(event) {
    let target = event.currentTarget,
      classList = target.classList;

    if (classList.contains('fa-chevron-up')) {
      classList.remove('fa-chevron-up');
      classList.add('fa-chevron-down');
      this.sortDir= 1;
    } else {
      classList.add('fa-chevron-up');
      classList.remove('fa-chevron-down');
      this.sortDir= -1;
    }
    this.sortArr('request_id');
  }

  sortArr(colName:any){
    this.userHistoryList.sort((a,b)=>{
      a= a[colName];
      b= b[colName];
    if (a.colName < b.colName) {
        return this.sortDir = 1;
      } 
       else {  
        return this.sortDir = -1;
      }
    //   return b-a;
    //   return a.toString().localeCompare(b) * this.sortDir;
    });
  }

}
